import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetEmspUsersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.form-default-values';
import { GetEmspUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.model';
import { useState } from 'react';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterEmspBoEmspUserListContextProvider,
  useEmspBoEmspUserListContext,
} from '../emsp-bo-emsp-user.context';
import { EmspUserListFilterFormController } from './emsp-user-list-filter-form/emsp-user-list-filter-form.controller';

interface EmspUserListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspUserListFilterController = ({
  onCancel,
  onSuccess,
}: EmspUserListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoEmspUserListContext();
  const [multiStepFormState] = useState(MultiStepFormState.Default);

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetEmspUsersPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-user-list-filter.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetEmspUsersPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      billingFrequency: fieldValues.billingFrequency,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetEmspUsersPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterEmspBoEmspUserListContextProvider data={data}>
      <EmspUserListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        state={multiStepFormState}
      />
    </FilterEmspBoEmspUserListContextProvider>
  );
};
